import { Injectable } from '@angular/core'

@Injectable({ providedIn: 'root' })
export class PivotFormStateService {
  private cache = new Map<string, Record<string, string>>()

  private key(huntId: string, queryId: string): string {
    return `${huntId}:${queryId}`
  }

  saveValues(
    huntId: string,
    queryId: string,
    values: Record<string, string>,
  ): void {
    this.cache.set(this.key(huntId, queryId), { ...values })
  }

  getValues(huntId: string, queryId: string): Record<string, string> {
    return this.cache.get(this.key(huntId, queryId)) ?? {}
  }

  clearValues(huntId: string, queryId: string): void {
    this.cache.delete(this.key(huntId, queryId))
  }
}
